
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import { SaleEditStateContactExtraInfoEdit } from "@/utils/sale-edit/sale-edit-state-contact-extra-info-edit";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		}
	},
	computed: {
		modalState():SaleEditStateContactExtraInfoEdit{
			return this.state.contactExtraInfoEditState;
		},
		title():TranslateResult{
			let groupName = this.modalState.getContactGroupName();
			return this.$ct("contact-extra-info-edit", {groupName});
		}
	},
	methods: {
		save(){
			if(this.state.sale.Contact){
				this.state.sale.Contact.Info=this.modalState.text;
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
